// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"157":"6a6eff21","234":"a37324ea"}[chunkId] + ".css";
};